import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromAuthStore from 'src/app/auth/store';
import { EMAIL_VALIDATION, MIN_LENGTH } from 'src/utils/constants';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
})
export class PasswordRecoveryComponent implements OnInit {
  form: FormGroup = new FormGroup({
    email: new FormControl(''),
  });

  constructor(
    private fb: FormBuilder,
    private authStore: Store<fromAuthStore.State>
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.minLength(MIN_LENGTH),
          Validators.pattern(EMAIL_VALIDATION),
        ],
      ],
    });
  }

  sendPasswordRecover() {
    this.authStore.dispatch(
      new fromAuthStore.RecoverPassword({
        email: this.form.get('email')?.value,
      })
    );
  }
}
